import React, { Fragment, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { fetchData, deleteData, activateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AsyncSelect from 'react-select/async';


export const CustomerCreate = (props) => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    /* API Call Post Method */
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    //Customer create
    const [names, setNames] = useState("");
    const [emails, setEmails] = useState("");
    const [gstNumbers, setGstNumbers] = useState("");
    const [contactNumber1s, setContactNumber1s] = useState("");
    const [contactNumber2s, setContactNumber2s] = useState("");
    const [addressline1s, setAddressLine1s] = useState("");
    const [addressline2s, setAddressLine2s] = useState("");
    const [landMarks, setLandMarks] = useState("");
    const [towns, setTowns] = useState("");
    const [pincodes, setPostcodes] = useState("");
    const [contactPersons, setcontactPersons] = useState("");
    const [districts, setDistricts] = useState("");
    const [states, setStates] = useState("");
    const [countrys, setCountrys] = useState("");

    const [customerRemarks, setCustomerRemarks] = useState("");

    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");
    const [warrentyDate, setWarrentyDate] = useState(new Date().toISOString().split('T')[0]); // Initialize with current date 
    const [renewalDate, setRenewalDate] = useState(new Date().toISOString().split('T')[0]); // Initialize with current date renewalDate


    const [pinCodess, setPinCodess] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);

    const fetchOptions = async (inputValue) => {
        if (inputValue.length <= 4) {
            return [];
        }

        const response = await fetchData('PinCodeApi', `/${companyId}/${inputValue}`, token);
        if (response) {
            const data = await response;
            setPinCodess(data);  // Move this line outside the if block
            return data.map(item => ({
                value: item.id,
                label: item.postcode,
            }));
        }
        return [];
    };

    const handleInputChange = (newValue) => newValue;

    const handleChangeDrop = (selectedOption) => {
        setSelectedOption(selectedOption);
        const selectedItemDetail = pinCodess.find(pincode => pincode.id === selectedOption.value);
        if (selectedItemDetail) {
            setTowns(selectedItemDetail.city);
            setDistricts(selectedItemDetail.district);
            setPostcodes(selectedItemDetail.postcode);
            setCountrys(selectedItemDetail.country);
            setStates(selectedItemDetail.state);
        }
    };

    //customer type

    const [selectedCustomer, setSelectedCustomer] = useState("");
    const [customerTypeOptions, setCustomerTypeOptions] = useState([]);
    const [selectedCustomerType, setSelectedCustomerType] = useState("");

    const fetchCustomerTypes = async () => {
        try {
            const response = await fetchData('CustomerTypeApi', `/${companyId}`);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(customer => ({
                    value: customer.id,
                    label: customer.type
                }));
                setCustomerTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Customer Types:', error);
        }
    };

    const handleCustomerTypeChange = (selectedOption) => {
        setSelectedCustomerType(selectedOption);
    };

    useEffect(() => {
        fetchCustomerTypes();
    }, []);

    const [selectedAMC, setSelectedAMC] = useState("1");
    const handleChange = (event) => {
        setSelectedAMC(event.target.value);
    };


    const handleToDateChange = (e) => {
        setRenewalDate(e.target.value);
    };
    const handleToDateChangeWarrentyDate = (e) => {
        setWarrentyDate(e.target.value);
    };

    //customerWarranty Options

    const [selectedCustomerWarrantyOptions, setSelectedCustomerWarrantyOptions] = useState("");
    const [customerWarrantyOptionsOptions, setCustomerWarrantyOptionsOptions] = useState([]);
    const [selectedCustomerWarrantyOptionsType, setSelectedCustomerWarrantyOptionsType] = useState("");

    const fetchCustomerWarrantyOptions = async () => {
        try {
            const response = await fetchData('ServiceRequestTypeApi', `/${companyId}`);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(customer => ({
                    value: customer.id,
                    label: customer.status
                }));
                setCustomerWarrantyOptionsOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Customer Types:', error);
        }
    };

    const handleCustomerWarrantyChange = (selectedOption) => {
        setSelectedCustomerWarrantyOptionsType(selectedOption);
    };

    useEffect(() => {
        fetchCustomerWarrantyOptions();
    }, []);

    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!names || !contactNumber1s) {
            setErrorMessages("All fields are required!");
            setIsLoading(false);
            return;
        }

        try {

            const CustomerCreateData = {
                CustomerName: names,
                CompanyID: companyId,
                CustomerTypeID: selectedCustomerType.value,
                ContactNumber1: contactNumber1s,
                ContactNumber2: contactNumber2s,
                Email: emails,
                GSTNumber: gstNumbers,
                AddressLine1: addressline1s,
                AdressLine2: addressline2s,
                LandMark: landMarks,
                PinCode: pincodes,
                Town: towns,
                District: districts,
                State: states,
                Country: countrys,
                GPSLocation: null,
                ContactPerson: contactPersons,
                CustomerRemark: customerRemarks,
                CreatedBy: userId,
                CreatedDate: new Date(),
                //AMC: selectedAMC,
                AMC: selectedCustomerWarrantyOptionsType.value,
                WarrentyExpireDate: warrentyDate || null,
                RenewalExpireDate: null
            };

            postData('CustomerApi', CustomerCreateData, token)
                .then((response) => {
                    console.log('Customer Created success:', response);
                    setNames("");
                    setContactNumber1s("");
                    setContactNumber2s("");
                    setAddressLine1s("");
                    setAddressLine2s("");
                    setPostcodes("");
                    setEmails("");
                    setGstNumbers("");
                    setPinCodess("");
                    setLandMarks("");
                    setTowns("");
                    setSelectedCustomerWarrantyOptionsType("");
                    setcontactPersons("");
                    setDistricts("");
                    setStates("");
                    setCountrys("");
                    setSelectedCustomerType("");
                    setCustomerRemarks("");
                    setSuccessMessages("customer Created successful!");
                    setErrorMessages(""); // Clear error message on success
                    history.push('/customerIndex');

                    setTimeout(() => {
                        setSuccessMessages("");
                    }, 3000); // 3 seconds
                })
                .catch((error) => {
                    console.error('Item Create error:', error);
                    setIsLoading(false);
                });


        }
        catch (error) {
            console.error('Item Create error:', error);
        }
    };

    /* End API */


    return (

        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">
                <div className="w-full mb-4 flex">

                    <form onSubmit={submitData}>

                        <div className='w-full mb-2 flex items-center'>
                            <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>CUSTOMER CREATE</h6>
                            <Tooltip title="Exit">
                                <Link to="/customerindex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                    <Button style={{ color: 'brown', fontWeight: 'bolder' }}>
                                        Back To List <ArrowForwardIosIcon />
                                    </Button>
                                </Link>
                            </Tooltip>
                            <Tooltip title="SAVE">

                                <Button onClick={submitData} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                                </Button>

                            </Tooltip>
                        </div>
                        {errorMessages && <p className="text-red-500">{errorMessages}</p>}
                        {successMessages && <p className="text-green-500">{successMessages}</p>}
                        <br></br>
                        <div className="w-full mb-4 flex">
                            <div className="w-1/4 mr-2">
                                <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                    Customer Type
                                </label>

                                <Select
                                    value={selectedCustomerType}
                                    onChange={handleCustomerTypeChange}
                                    options={customerTypeOptions}
                                    placeholder="Customer-Type"
                                    isSearchable
                                />
                            </div>
                            <div className="w-1/4 mr-2">
                                <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="code" style={{ fontSize: '14px' }}>
                                    Name
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={names}
                                    onChange={(e) => setNames(e.target.value)}
                                    type="text"
                                    placeholder="Enter Name"
                                />
                            </div>
                            {selectedCustomerType && (selectedCustomerType.label === 'IGST' || selectedCustomerType.label === 'B to B') && (

                                <div className="w-1/4 mr-2">
                                    <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="code" style={{ fontSize: '14px' }}>
                                        Contact Person
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={contactPersons}
                                        onChange={(e) => setcontactPersons(e.target.value)}
                                        type="text"
                                        placeholder="Contact person"
                                    />
                                </div>
                            )}
                            <div className="w-1/4 mr-2">
                                <label className="block tracking-wide text-black text-base mb-2" htmlFor="contactNumber1">
                                    ContactNo:1
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={contactNumber1s}
                                    onChange={(e) => {
                                        const input = e.target.value.replace(/\D/g, '');
                                        if (input.length <= 15) {
                                            setContactNumber1s(input);
                                        }
                                    }}
                                    type="text"
                                    placeholder="Contact Number 1"
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block tracking-wide text-black text-base mb-2" htmlFor="contactNumber2">
                                    ContactNo:2
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={contactNumber2s}
                                    onChange={(e) => {
                                        const input = e.target.value.replace(/\D/g, '');
                                        if (input.length <= 15) {
                                            setContactNumber2s(input);
                                        }
                                    }}
                                    type="text"
                                    placeholder="Contact Number 2"
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="email">
                                    Email
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={emails} onChange={(e) => setEmails(e.target.value)} type="text" placeholder="Email" />
                            </div>


                        </div>

                        <div className="w-full mb-4 flex">
                            {selectedCustomerType && (selectedCustomerType.label === 'IGST' || selectedCustomerType.label === 'B to B') && (
                                <div className="w-1/4 mr-2">
                                    <label className="block  tracking-wide text-black text-base mb-2" htmlFor="gstNumber">
                                        GST Number
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={gstNumbers} onChange={(e) => setGstNumbers(e.target.value)} maxLength={15} type="text" placeholder="GST Number" />
                                </div>
                            )}

                            <div className="w-1/2 mr-2">
                                <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="AddressLine1">
                                    Address Line 1
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={addressline1s} onChange={(e) => setAddressLine1s(e.target.value)} type="text" placeholder="Address Line 1" />
                            </div>

                            <div className="w-1/2 mr-2">
                                <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="AddressLine2">
                                    Address Line 2
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={addressline2s} onChange={(e) => setAddressLine2s(e.target.value)} type="text" placeholder="Address Line 2" />
                            </div>

                        </div>
                        <div className="w-full mb-4 flex">
                            <div className="w-1/2 mr-2">
                                <label className="block tracking-wide text-black text-base  mb-2" htmlFor="PinCode">
                                    PIN Code
                                </label>

                                <AsyncSelect
                                    cacheOptions
                                    loadOptions={fetchOptions}
                                    onInputChange={handleInputChange}
                                    onChange={handleChangeDrop}
                                    value={selectedOption}
                                />
                            </div>

                            <div className="w-1/2 mr-2">
                                <label className="block  tracking-wide text-black text-base mb-2" htmlFor="LandMark">
                                    LandMark
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={landMarks} onChange={(e) => setLandMarks(e.target.value)} type="text" placeholder="Landmark" />
                            </div>
                            <div className="w-1/2 mr-2">
                                <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="Town">
                                    City
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={towns} onChange={(e) => setTowns(e.target.value)} type="text" placeholder="City" />
                            </div>

                            <div className="w-1/2 mr-2">
                                <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="District">
                                    District
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={districts} onChange={(e) => setDistricts(e.target.value)} type="text" placeholder="District" />
                            </div>

                            <div className="w-1/2 mr-2">
                                <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="State">
                                    State
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={states} onChange={(e) => setStates(e.target.value)} type="text" placeholder="State" />
                            </div>
                            <div className="w-1/2 mr-2">
                                <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="Country">
                                    Country
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={countrys} onChange={(e) => setCountrys(e.target.value)} type="text" placeholder="Country" readOnly />
                            </div>
                        </div>
                        <div className="w-full mb-4 flex flex-wrap">
                            <div className="w-full md:w-1/6 mr-2">
                                <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                    Customer Warranty Options
                                </label>
                                <Select
                                    value={selectedCustomerWarrantyOptionsType}
                                    onChange={handleCustomerWarrantyChange}
                                    options={customerWarrantyOptionsOptions}
                                    placeholder="Warranty Options"
                                    isSearchable
                                />
                            </div>

                            {(selectedCustomerWarrantyOptionsType.label === "AMC" || selectedCustomerWarrantyOptionsType.label === "WARRANTY") && (
                                <div className="w-full md:w-1/6 mr-2">
                                    <label
                                        className="block tracking-wide  text-xs mb-2"
                                        htmlFor="toDate"
                                        style={{ fontSize: '15px', fontWeight: 'bold', color: 'red' }}
                                    >
                                        Warranty Expired Date
                                    </label>
                                    <input
                                        type="date"
                                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                        value={warrentyDate || ''}
                                        onChange={handleToDateChangeWarrentyDate}
                                    />
                                </div>
                            )}

                            <div className="w-full md:w-1/2 mr-2">
                                <label className="block tracking-wide text-black text-xs mb-2" htmlFor="packingDate" style={{ fontSize: '16px' }}>
                                    Remark
                                </label>
                                <textarea
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={customerRemarks}
                                    onChange={(e) => setCustomerRemarks(e.target.value)}
                                    placeholder="Enter Remarks"
                                    rows={3}
                                    maxLength={250}
                                />
                            </div>

                        </div>

                    </form>
                </div>
            </div>

        </Fragment>
    );
}


